module.exports = __webpack_public_path__ + "static/img/advertisement02.963a2400.jpg";